// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Users, FolderPlus, ListFilter, Folder } from "lucide-react";

// // Reusable local field component matching inline structures
// const LocalField = ({ label, placeholder, select, options, required, value, onChange }) => (
//   <div style={{ display: "flex", flexDirection: "column", gap: "4px", width: "100%" }}>
//     <label style={{ fontSize: "12px", fontWeight: "600", color: "#475569" }}>
//       {label} {required && <span style={{ color: "#ef4444" }}>*</span>}
//     </label>
//     {select ? (
//       <select
//         value={value}
//         onChange={onChange}
//         style={{ padding: "8px", borderRadius: "6px", border: "1px solid #cbd5e1", fontSize: "13px", backgroundColor: "#fff" }}
//       >
//         <option value="">Select an option</option>
//         {options?.map((opt, i) => {
//           const val = typeof opt === "object" ? (opt.name || opt.table_name || opt.id) : opt;
//           const boundValue = typeof opt === "object" ? (opt.id || opt.table_name || opt.name) : opt;
//           return <option key={i} value={boundValue}>{val}</option>;
//         })}
//       </select>
//     ) : (
//       <input
//         type="text"
//         placeholder={placeholder}
//         value={value}
//         onChange={onChange}
//         style={{ padding: "8px", borderRadius: "6px", border: "1px solid #cbd5e1", fontSize: "13px" }}
//       />
//     )}
//   </div>
// );

// const AddGrop = () => {
//   const [newGroup1, setNewGroup1] = useState("");
//   const [selectedGroup1, setSelectedGroup1] = useState("");
//   const [newSubgroup1, setNewSubgroup1] = useState("");
//   const [groups1, setGroups1] = useState([]);
//   const [subgroups1, setSubgroups1] = useState([]);

//   // Base state loaders to coordinate view state refreshes
//   const fetchGroups1 = () => {
//     const user = JSON.parse(sessionStorage.getItem('user'));
//     if (!user) return;
//     const emailToUse = user.role === "admin" ? user.id : user.userId;
//     axios.get(`https://botapi.emedha.in/pages/api/apiwer/groups?user_id=${emailToUse}`)
//       .then(response => {
//         setGroups1(response.data);
//       })
//       .catch(error => console.error('Error fallback context groups loading:', error));
//   };

//   const fetchSubGroups1 = () => {
//     const user = JSON.parse(sessionStorage.getItem('user'));
//     if (!user) return;
//     const emailToUse = user.role === "admin" ? user.id : user.userId;
//     axios.get(`https://botapi.emedha.in/pages/api/api/subgroups?user_id=${emailToUse}`)
//       .then(response => {
//         const groupsData = response.data;
//         let filteredGroups;
//         if (user.role === "admin") {
//           filteredGroups = groupsData;
//         } else if (user.role === "member") {
//           filteredGroups = groupsData.filter(group => group.role === "member" && group.member_id === user.id);
//         }
//         setSubgroups1(filteredGroups || []);
//       })
//       .catch(error => console.error('Error fetching subgroups sync contexts:', error));
//   };

//   // Initial Sync Pipeline
//   useEffect(() => {
//     fetchGroups1();
//     fetchSubGroups1();
//   }, []);

//   // API Call: Step 1 Create Group Action
//   const handleAddGroup1 = () => {
//     const storedUser = JSON.parse(sessionStorage.getItem('user'));
//     if (!storedUser) {
//       alert("User not logged in");
//       return;
//     }
//     if (!newGroup1.trim()) {
//       alert("Please enter a group name!");
//       return;
//     }

//     const isAdmin = storedUser.role === "admin";
//     const isMember = storedUser.role === "member";
//     const adminId = isAdmin ? storedUser.id : storedUser.userId;
//     const memberId = isMember ? storedUser.id : null;

//     const payload = {
//       name: newGroup1,
//       user_id: adminId,
//       role: storedUser.role,
//     };

//     if (isMember) {
//       payload.member_id = memberId;
//     }

//     axios.post("https://botapi.emedha.in/pages/api/api/groups", payload)
//       .then((res) => {
//         alert("Group created successfully!");
//         setNewGroup1("");
//         fetchGroups1();
//       })
//       .catch((err) => {
//         console.error("Create group failed:", err);
//         alert("Error creating group");
//       });
//   };

//   // API Call: Step 2 Create Subgroup Action
//   const handleAddSubgroup1 = () => {
//     const user = JSON.parse(sessionStorage.getItem('user'));
//     if (!user || !user.id) {
//       alert('User not logged in');
//       return;
//     }
//     if (!selectedGroup1 || !newSubgroup1.trim()) {
//       alert('Both group and subgroup name are required!');
//       return;
//     }

//     const selectedGroup = groups1.find(group => String(group.id) === String(selectedGroup1));
//     if (!selectedGroup) {
//       alert('Group not found reference tracking details!');
//       return;
//     }

//     const isAdmin = user.role === "admin";
//     const isMember = user.role === "member";
//     const adminId = isAdmin ? user.id : user.userId;
//     const memberId = isMember ? user.id : null;

//     const payload = {
//       name: newSubgroup1,
//       group_id: selectedGroup.id,
//       user_id: adminId,
//       role: user.role,
//     };

//     if (isMember) {
//       payload.member_id = memberId;
//     }

//     axios.post('https://botapi.emedha.in/pages/api/api/subgroups', payload)
//       .then(response => {
//         alert('Subgroup added successfully!');
//         setNewSubgroup1('');
//         fetchSubGroups1();
//       })
//       .catch(error => {
//         console.error('Error adding subgroup:', error);
//         alert('Error adding subgroup');
//       });
//   };

//   return (
//     <div style={{ fontFamily: "system-ui, sans-serif", backgroundColor: "#f8fafc", minHeight: "100vh" }}>
//       {/* Header */}
//       <div style={{ marginBottom: "24px", display: "flex", alignItems: "center", gap: "10px" }}>
//         <div style={{ backgroundColor: "#e0f2fe", borderRadius: "8px", display: "flex", padding: "8px", color: "#0369a1" }}>
//           <Users size={20} />
//         </div>
//         <div>
//           <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "700", color: "#1e293b" }}>Group & Subgroup Management</h2>
//           <p style={{ margin: 0, fontSize: "13px", color: "#64748b" }}>Create structural hierarchies for your contact lists.</p>
//         </div>
//       </div>

//       {/* Structural management section */}
//       <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "24px", marginBottom: "32px" }}>
//         {/* --- STEP 1: CREATE GROUP --- */}
//         <div style={{ background: "#fff", padding: "20px", borderRadius: "12px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", border: "1px solid #e2e8f0" }}>
//           <h3 style={{ marginTop: 0, marginBottom: "16px", fontSize: "15px", color: "#1e293b" }}>1. Create Group</h3>
//           <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//             <LocalField
//               label="Group Name"
//               placeholder="Enter new group name"
//               required
//               value={newGroup1}
//               onChange={(e) => setNewGroup1(e.target.value)}
//             />

//             <div style={{ fontSize: "12px", color: "#2563eb", fontWeight: "500", display: "flex", alignItems: "center", gap: "4px" }}>
//               If you want to create a sub-group, look at the next card.
//             </div>

//             <LocalField
//               label="Select a Group (To view/edit)"
//               select
//               options={groups1}
//               value={selectedGroup1}
//               onChange={(e) => setSelectedGroup1(e.target.value)}
//             />

//             <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
//               <button
//                 onClick={handleAddGroup1}
//                 style={{ width: "100%", padding: "10px", backgroundColor: "#2563eb", color: "#fff", border: "none", borderRadius: "6px", fontWeight: "600", cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center", gap: "6px" }}
//               >
//                 <FolderPlus size={14} /> Create Group
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* --- STEP 2: CREATE SUBGROUP --- */}
//         <div style={{ background: "#fff", padding: "20px", borderRadius: "12px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", border: "1px solid #e2e8f0" }}>
//           <h3 style={{ marginTop: 0, marginBottom: "16px", fontSize: "15px", color: "#1e293b" }}>2. Create Subgroup</h3>
//           <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//             <LocalField
//               label="Select Parent Group"
//               select
//               options={groups1}
//               value={selectedGroup1}
//               onChange={(e) => setSelectedGroup1(e.target.value)}
//               required
//             />
//             <LocalField
//               label="Subgroup Name"
//               placeholder="Enter new subgroup name"
//               required
//               value={newSubgroup1}
//               onChange={(e) => setNewSubgroup1(e.target.value)}
//             />

//             <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
//               <button
//                 onClick={handleAddSubgroup1}
//                 style={{ width: "100%", padding: "10px", backgroundColor: "#2563eb", color: "#fff", border: "none", borderRadius: "6px", fontWeight: "600", cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center", gap: "6px" }}
//               >
//                 <FolderPlus size={14} /> Create Subgroup
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* --- LIVE STRUCTURE HIERARCHY LIST --- */}
//       <div style={{ background: "#fff", padding: "24px", borderRadius: "12px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", border: "1px solid #e2e8f0" }}>
//         <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px", borderBottom: "1px solid #f1f5f9", paddingBottom: "12px" }}>
//           <ListFilter size={18} style={{ color: "#475569" }} />
//           <h3 style={{ margin: 0, fontSize: "16px", fontWeight: "600", color: "#1e293b" }}>Active Hierarchy Explorer</h3>
//         </div>

//         {groups1.length === 0 ? (
//           <div style={{ textAlign: "center", padding: "24px", color: "#94a3b8", fontSize: "14px" }}>
//             No groups found. Create your first tracking structure above.
//           </div>
//         ) : (
//           <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: "16px" }}>
//             {groups1.map((group) => {
//               const connectedSubgroups = subgroups1.filter(sub => String(sub.group_id) === String(group.id));
              
//               return (
//                 <div key={group.id} style={{ border: "1px solid #e2e8f0", borderRadius: "8px", backgroundColor: "#f8fafc", padding: "14px" }}>
//                   <div style={{ display: "flex", alignItems: "center", gap: "8px", fontWeight: "600", color: "#0f172a", fontSize: "14px", marginBottom: "8px" }}>
//                     <Folder size={16} style={{ color: "#2563eb" }} />
//                     <span>{group.name}</span>
//                     <span style={{ fontSize: "11px", fontWeight: "normal", backgroundColor: "#e2e8f0", color: "#475569", padding: "2px 6px", borderRadius: "10px", marginLeft: "auto" }}>
//                       ID: {group.id}
//                     </span>
//                   </div>
                  
//                   <div style={{ borderTop: "1px dashed #cbd5e1", paddingTop: "8px", display: "flex", flexDirection: "column", gap: "6px" }}>
//                     <span style={{ fontSize: "11px", fontWeight: "600", color: "#64748b", uppercase: "true" }}>
//                       Subgroups ({connectedSubgroups.length}):
//                     </span>
//                     {connectedSubgroups.length === 0 ? (
//                       <span style={{ fontSize: "12px", color: "#94a3b8", fontStyle: "italic", paddingLeft: "8px" }}>
//                         None mapped
//                       </span>
//                     ) : (
//                       <ul style={{ margin: 0, paddingLeft: "18px", fontSize: "13px", color: "#334155" }}>
//                         {connectedSubgroups.map((sub) => (
//                           <li key={sub.id} style={{ marginBottom: "2px" }}>{sub.name}</li>
//                         ))}
//                       </ul>
//                     )}
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AddGrop;
















import React, { useState, useEffect } from "react";
import axios from "axios";
import { Users, FolderPlus, ListFilter, Folder, Layers, Edit2, Trash2 } from "lucide-react";

// Reusable local field component matching inline structures
const LocalField = ({ label, placeholder, select, options, required, value, onChange }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: "4px", width: "100%" }}>
    <label style={{ fontSize: "12px", fontWeight: "600", color: "#475569" }}>
      {label} {required && <span style={{ color: "#ef4444" }}>*</span>}
    </label>
    {select ? (
      <select
        value={value}
        onChange={onChange}
        style={{ padding: "8px", borderRadius: "6px", border: "1px solid #cbd5e1", fontSize: "13px", backgroundColor: "#fff" }}
      >
        <option value="">Select an option</option>
        {options?.map((opt, i) => {
          const val = typeof opt === "object" ? (opt.name || opt.table_name || opt.id) : opt;
          const boundValue = typeof opt === "object" ? (opt.id || opt.table_name || opt.name) : opt;
          return <option key={i} value={boundValue}>{val}</option>;
        })}
      </select>
    ) : (
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        style={{ padding: "8px", borderRadius: "6px", border: "1px solid #cbd5e1", fontSize: "13px" }}
      />
    )}
  </div>
);

const AddGrop = () => {
  const [newGroup1, setNewGroup1] = useState("");
  const [selectedGroup1, setSelectedGroup1] = useState("");
  const [newSubgroup1, setNewSubgroup1] = useState("");
  const [groups1, setGroups1] = useState([]);
  const [subgroups1, setSubgroups1] = useState([]);

  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Base state loaders to coordinate view state refreshes
  const fetchGroups1 = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    if (!user) return;
    const emailToUse = user.role === "admin" ? user.id : user.userId;
    axios.get(`https://botapi.emedha.in/pages/api/apiwer/groups?user_id=${emailToUse}`)
      .then(response => {
        setGroups1(response.data);
      })
      .catch(error => console.error('Error fallback context groups loading:', error));
  };

  const fetchSubGroups1 = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    if (!user) return;
    const emailToUse = user.role === "admin" ? user.id : user.userId;
    axios.get(`https://botapi.emedha.in/pages/api/api/subgroups?user_id=${emailToUse}`)
      .then(response => {
        const groupsData = response.data;
        let filteredGroups;
        if (user.role === "admin") {
          filteredGroups = groupsData;
        } else if (user.role === "member") {
          filteredGroups = groupsData.filter(group => group.role === "member" && group.member_id === user.id);
        }
        setSubgroups1(filteredGroups || []);
      })
      .catch(error => console.error('Error fetching subgroups sync contexts:', error));
  };

  // Initial Sync Pipeline
  useEffect(() => {
    fetchGroups1();
    fetchSubGroups1();
  }, []);

  // API Call: Step 1 Create Group Action
  const handleAddGroup1 = () => {
    const storedUser = JSON.parse(sessionStorage.getItem('user'));
    if (!storedUser) {
      alert("User not logged in");
      return;
    }
    if (!newGroup1.trim()) {
      alert("Please enter a group name!");
      return;
    }

    const isAdmin = storedUser.role === "admin";
    const isMember = storedUser.role === "member";
    const adminId = isAdmin ? storedUser.id : storedUser.userId;
    const memberId = isMember ? storedUser.id : null;

    const payload = {
      name: newGroup1,
      user_id: adminId,
      role: storedUser.role,
    };

    if (isMember) {
      payload.member_id = memberId;
    }

    axios.post("https://botapi.emedha.in/pages/api/api/groups", payload)
      .then((res) => {
        alert("Group created successfully!");
        setNewGroup1("");
        fetchGroups1();
      })
      .catch((err) => {
        console.error("Create group failed:", err);
        alert("Error creating group");
      });
  };

  // API Call: Step 2 Create Subgroup Action
  const handleAddSubgroup1 = (parentId) => {
    if (!newSubgroup1.trim()) {
      alert('Please enter a subgroup name!');
      return;
    }

    const user = JSON.parse(sessionStorage.getItem('user'));
    if (!user || !user.id) {
      alert('User not logged in');
      return;
    }

    const isAdmin = user.role === "admin";
    const isMember = user.role === "member";
    const adminId = isAdmin ? user.id : user.userId;
    const memberId = isMember ? user.id : null;

    const payload = {
      name: newSubgroup1,
      group_id: parentId,
      user_id: adminId,
      role: user.role,
    };

    if (isMember) {
      payload.member_id = memberId;
    }

    axios.post('https://botapi.emedha.in/pages/api/api/subgroups', payload)
      .then(response => {
        alert('Subgroup added successfully!');
        setNewSubgroup1('');
        fetchSubGroups1();
      })
      .catch(error => {
        console.error('Error adding subgroup:', error);
        alert('Error adding subgroup');
      });
  };

  // --- Actions Placeholders (Disabled for you to implement later) ---
  const handleEditGroup = (group) => {
    // Left empty/disabled for changes down the line
    // console.log("Edit Group triggered for ID:", group.id);
  };

  const handleDeleteGroup = (groupId) => {
    // Left empty/disabled for changes down the line
    // console.log("Delete Group triggered for ID:", groupId);
  };

  const handleEditSubgroup = (subgroup) => {
    // Left empty/disabled for changes down the line
    // console.log("Edit Subgroup triggered for ID:", subgroup.id);
  };

  const handleDeleteSubgroup = (subgroupId) => {
    // Left empty/disabled for changes down the line
    // console.log("Delete Subgroup triggered for ID:", subgroupId);
  };

  // --- Pagination Math ---
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentGroups = groups1.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(groups1.length / itemsPerPage) || 1;

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  return (
    <div style={{ fontFamily: "system-ui, sans-serif", backgroundColor: "#f8fafc", minHeight: "100vh" }}>
      {/* Header */}
      <div style={{ marginBottom: "24px", display: "flex", alignItems: "center", gap: "10px" }}>
        <div style={{ backgroundColor: "#e0f2fe", borderRadius: "8px", display: "flex", padding: "8px", color: "#0369a1" }}>
          <Users size={20} />
        </div>
        <div>
          <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "700", color: "#1e293b" }}>Group & Subgroup</h2>
          <p style={{ margin: 0, fontSize: "13px", color: "#64748b" }}>Your contact lists.</p>
        </div>
      </div>

      {/* Structural management section */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "24px", marginBottom: "32px" }}>
        {/* --- STEP 1: CREATE GROUP --- */}
        <div style={{ background: "#fff", padding: "20px", borderRadius: "12px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", border: "1px solid #e2e8f0" }}>
          <h3 style={{ marginTop: 0, marginBottom: "16px", fontSize: "15px", color: "#1e293b", fontWeight: "600" }}>Create Group</h3>
          <div style={{ display: "flex", gap: "16px", alignItems: "flex-end" }}>
            <div style={{ flex: 1 }}>
              <LocalField
                label="Group Name"
                placeholder="Enter group name"
                required
                value={newGroup1}
                onChange={(e) => setNewGroup1(e.target.value)}
              />
            </div>
            <button
              onClick={handleAddGroup1}
              style={{ height: "38px", padding: "0 16px", backgroundColor: "#2563eb", color: "#fff", border: "none", borderRadius: "6px", fontWeight: "600", cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center", gap: "6px" }}
            >
              <FolderPlus size={14} /> Create Group
            </button>
          </div>
        </div>
      </div>

      {/* --- LIVE STRUCTURE HIERARCHY TABLE FORMAT --- */}
      <div style={{ background: "#fff", borderRadius: "12px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", border: "1px solid #e2e8f0", overflow: "hidden" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px", padding: "20px 24px", borderBottom: "1px solid #f1f5f9" }}>
          <ListFilter size={18} style={{ color: "#475569" }} />
          <h3 style={{ margin: 0, fontSize: "16px", fontWeight: "600", color: "#1e293b" }}>Groups & Subgroups</h3>
        </div>

        {groups1.length === 0 ? (
          <div style={{ textAlign: "center", padding: "40px 24px", color: "#94a3b8", fontSize: "14px" }}>
            No parent groups found. Create your first parent group tracking structure above.
          </div>
        ) : (
          <>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left", fontSize: "14px" }}>
                <thead>
                  <tr style={{ backgroundColor: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                     <th style={{ padding: "14px 24px", fontWeight: "600", color: "#475569", width: "250px" }}>Group Name</th>
                    <th style={{ padding: "14px 24px", fontWeight: "600", color: "#475569" }}>Subgroups</th>
                    {/* Action header left in place but elements inside table logic below are commented/disabled */}
                    <th style={{ padding: "14px 24px", fontWeight: "600", color: "#475569", width: "120px", textAlign: "right" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentGroups.map((group) => {
                    const connectedSubgroups = subgroups1.filter(sub => String(sub.group_id) === String(group.id));
                    
                    return (
                      <tr key={group.id} style={{ borderBottom: "1px solid #f1f5f9", transition: "background-color 0.2s" }}>            
                        {/* Parent Group Name Column */}
                        <td style={{ padding: "16px 24px", fontWeight: "600", color: "#0f172a", verticalAlign: "top" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <Folder size={16} style={{ color: "#2563eb", flexShrink: 0 }} />
                            <span>{group.name}</span>
                          </div>
                        </td>

                        {/* Inside Table Inline Subgroups & Inner Input Action */}
                        <td style={{ padding: "16px 24px", verticalAlign: "top" }}>
                          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                            
                            {/* Inner list of existing elements */}
                            {connectedSubgroups.length === 0 ? (
                              <span style={{ fontSize: "13px", color: "#94a3b8", fontStyle: "italic" }}>
                                No subgroups added yet.
                              </span>
                            ) : (
                              <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                                {connectedSubgroups.map((sub) => (
                                  <div 
                                    key={sub.id} 
                                    style={{ 
                                      display: "inline-flex", 
                                      alignItems: "center", 
                                      gap: "6px", 
                                      backgroundColor: "#eff6ff", 
                                      color: "#1e40af", 
                                      border: "1px solid #bfdbfe", 
                                      padding: "4px 8px", 
                                      borderRadius: "6px",
                                      fontSize: "12px",
                                      fontWeight: "500"
                                    }}
                                  >
                                    <Layers size={11} style={{ color: "#3b82f6" }} />
                                    <span>{sub.name}</span>
                                    
                                    {/* Inline subgroup modifiers commented out / disabled */}
                                    {/* 
                                    <div style={{ display: "flex", gap: "4px", marginLeft: "6px", borderLeft: "1px solid #bfdbfe", paddingLeft: "6px" }}>
                                      <button onClick={() => handleEditSubgroup(sub)} style={{ border: "none", background: "none", color: "#2563eb", cursor: "pointer", padding: 0 }}><Edit2 size={11} /></button>
                                      <button onClick={() => handleDeleteSubgroup(sub.id)} style={{ border: "none", background: "none", color: "#ef4444", cursor: "pointer", padding: 0 }}><Trash2 size={11} /></button>
                                    </div> 
                                    */}
                                  </div>
                                ))}
                              </div>
                            )}

                            {/* Quick Inline Creation Input Frame */}
                            <div style={{ display: "flex", gap: "8px", maxWidth: "340px", marginTop: "4px" }}>
                              <input 
                                type="text" 
                                placeholder="New subgroup name..."
                                onChange={(e) => setNewSubgroup1(e.target.value)}
                                style={{ flex: 1, padding: "4px 8px", fontSize: "12px", borderRadius: "4px", border: "1px solid #cbd5e1" }}
                              />
                              <button 
                                onClick={() => handleAddSubgroup1(group.id)}
                                style={{ padding: "4px 10px", backgroundColor: "#0f172a", color: "#fff", fontSize: "12px", border: "none", borderRadius: "4px", cursor: "pointer", fontWeight: "500" }}
                              >
                                Add Sub
                              </button>
                            </div>
                          </div>
                        </td>

                        {/* Parent Group Action Controls commented out / disabled */}
                        <td style={{ padding: "16px 24px", textAlign: "right", verticalAlign: "top" }}>
                          <span style={{ fontSize: "12px", color: "#94a3b8", fontStyle: "italic" }}>No Actions</span>
                          {/* 
                          <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                            <button onClick={() => handleEditGroup(group)} style={{ padding: "6px", borderRadius: "6px", border: "1px solid #cbd5e1", backgroundColor: "#fff", color: "#475569", cursor: "pointer" }}><Edit2 size={14} /></button>
                            <button onClick={() => handleDeleteGroup(group.id)} style={{ padding: "6px", borderRadius: "6px", border: "1px solid #fca5a5", backgroundColor: "#fef2f2", color: "#ef4444", cursor: "pointer" }}><Trash2 size={14} /></button>
                          </div> 
                          */}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 24px", borderTop: "1px solid #e2e8f0", backgroundColor: "#f8fafc" }}>
              <span style={{ fontSize: "13px", color: "#64748b" }}>
                Showing {groups1.length > 0 ? indexOfFirstItem + 1 : 0} to {Math.min(indexOfLastItem, groups1.length)} of {groups1.length} entries
              </span>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <button
                  onClick={handlePrevPage}
                  disabled={currentPage === 1}
                  style={{
                    padding: "6px 12px", borderRadius: "6px", fontSize: "13px", fontWeight: "500",
                    border: "1px solid #cbd5e1", backgroundColor: "#fff", color: currentPage === 1 ? "#cbd5e1" : "#475569",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer"
                  }}
                >
                  Previous
                </button>
                <span style={{ fontSize: "13px", fontWeight: "600", color: "#1e293b" }}>
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                  style={{
                    padding: "6px 12px", borderRadius: "6px", fontSize: "13px", fontWeight: "500",
                    border: "1px solid #cbd5e1", backgroundColor: "#fff", color: currentPage === totalPages ? "#cbd5e1" : "#475569",
                    cursor: currentPage === totalPages ? "not-allowed" : "pointer"
                  }}
                >
                  Next
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AddGrop;